<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-chip v-bind="attrs" v-on="on" :class="`warning-chip ${chip ? '' : 'warning-div'} ${isHidden ? 'hide-chip' : ''}`"
        :color="`${formatIsCorrect || (isVat && numberIsCorrect) ? 'success' : 'warning'}`" outlined small
        @click="isDialog = enableRDWebService && numberIsCorrect">
        <v-icon dense :class="`${hideDetails ? 'hide-icon' : ''}`">{{ formatIsCorrect || (isVat && numberIsCorrect)
          ? 'mdi-check-circle' : 'mdi-alert' }}</v-icon>
        <span v-if="!hideDetails" v-html="text"></span>
      </v-chip>
    </template>
    <div v-html="tooltipText"></div>
    <v-dialog v-model="isDialog" max-width="1000px" scrollable>
      <v-card>
        <v-card-title class="space-between">
          <div>{{ $t('customer.check_citizen_id') }}</div>
          <v-btn elevation="0" @click="isDialog = false" icon :disabled="isLoading" :loading="isLoading">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-overlay v-if="isLoading" color="white" absolute opacity="1">
          <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        </v-overlay>
        <v-card-text class="container-box">
          <div class="header-tax">
            <div>{{ $t('validate.check_the_correctness_of_tax_id_and_citizen_id') }}</div>
            <div>{{ $t('number') }} <b>{{ value }}</b></div>
          </div>
          <div v-if="dataTIN" class="box-id-check">
            <div class="status-box">
              <div class="header-status">{{ $t('validate.check_the_correctness_of_tin_service') }}</div>
              <v-icon :color="dataTIN.ststusChecked.color">{{ dataTIN.ststusChecked.icon }}</v-icon>
              <div class="text-status">{{ dataTIN.ststusChecked.text }}</div>
            </div>
            <div>
              <div>{{ $t('payment.inspection_results') }} : {{ dataTIN.DigitOkText }} </div>
              <div>{{ $t('tax.is_in_tax_department_database') }} : {{ dataTIN.IsExistText }} </div>
            </div>
          </div>
          <div v-if="dataVAT" class="box-id-check">
            <div class="status-box">
              <div class="header-status">{{ $t('validate.check_the_correctness_of_vat_service') }}</div>
              <v-icon :color="dataVAT.ststusChecked.color">{{ dataVAT.ststusChecked.icon }}</v-icon>
              <div class="text-status">{{ dataVAT.ststusChecked.text }}</div>
            </div>

            <div v-if="dataVAT.ststusChecked.value == 'checked'" class="company-data-box">
              <div class="company-name">{{ dataVAT.companyName }}</div>
              <div>{{ dataVAT.fullAddress }}</div>
              <v-btn color="info" @click="isShowTINFieldData = !isShowTINFieldData" plain>{{ isShowTINFieldData ? $t('hide')
                : $t('view') }}{{ $t('detail') }}</v-btn>
              <div :class="`${!isShowTINFieldData ? 'hide-data' : ''}`">
                <div v-for="(data, index) of dataVAT" :key="index" v-if="showTINFieldData.includes(index)">
                  {{ index }} : {{ data }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="!dataTIN || (isVat && !dataVAT)" class="box-error">
            <div>{{ $t('validate.error_occurred_while_using_the_service') }}</div>
            <div>{{ $t('validate.or_cannot_use_the_service_in_this_time') }}</div>
          </div>
          <div class="note right">
            <span>{{ $t('customer.check_by') }} <a href="https://www.rd.go.th/42545.html" target="_blank" rel="noopener noreferrer">Web
                services</a></span>
            <img class="logo" src="../assets/images/logo-rd.svg" :alt="$t('customer.logo_tax_department')">
          </div>
          <div class="note">
            {{ $t('validate.tin_service_description') }}
          </div>
          <div class="note" v-if="isVat">
            {{ $t('validate.vat_service_description') }}
          </div>
          <div class="note" v-if="false">
            Checking for validation and existence of Tax Identification Number (TIN) and Personal Identification
            Number(PIN) to prevent forging.
          </div>
          <div class="note" v-if="false">
            Providing comprehensive information of taxpayer who are the Value-added tax registrants. This will help a
            business to verify whether its partner can legally issue the tax invoice in accordance with the tax law in
            order to check if the tax invoice received is legal for his input tax credit. The service can also verify the
            existence of the business partner.
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="isDialog = false" :disabled="isLoading"
            :loading="isLoading">{{ $t('close') }}</v-btn>
          <v-btn color="success" type="submit" elevation="0" :disabled="isLoading || !dataVAT || dataVAT.msgerr != '-'"
            :loading="isLoading" v-if="isVat && isExport" @click="checkTaxIDFn()">{{ $t('project.import_data') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-tooltip>
</template>

<script>
import helper from '@/mixins/helper.js'
import { mapActions, mapGetters } from "vuex";
import { Market } from "@/classes";
export default {
  name: "WarningCitizenIdIcon",
  mixins: [helper],
  props: {
    value: String,
    hideDetails: {
      type: Boolean,
      default: false
    },
    successText: {
      type: String,
      default: ''
    },
    warningText: {
      type: String,
      default: ''
    },
    chip: {
      type: Boolean,
      default: true
    },
    isVat: {
      type: Boolean,
      default: false
    },
    isExport: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.internalSuccessText = this.successText || this.$t('project.correct_format');
    this.internalWarningText = this.warningText || this.$t('project.incorrect_format');
  },
  computed: {
    ...mapGetters({
      getMarketEnableRDWebService: "markets/getMarketEnableRDWebService",
    }),
  },
  watch: {
    value: {
      handler(citizenId) {
        if (!this.isFirst)
          this.initData(citizenId)
      },
      deep: true,
      immediate: true
    },
    isDialog: {
      async handler(isDialog) {
        if (isDialog) {
          this.isLoading = true
          try {
            this.dataTIN = await this.checkTaxID({ taxId: this.value, isVat: false })
            if (this.isVat) this.dataVAT = await this.checkTaxID({ taxId: this.value, isVat: true })
          } catch (error) {
            console.log(error)
            this.isLoading = false
            this.dataTIN = null
            this.dataVAT = null
          }
          this.isLoading = false
        } else {
          this.dataTIN = null
          this.dataVAT = null
          this.isShowTINFieldData = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  async mounted() {
    let market
    try {
      if (this.marketId)
        market = await this.getMarket({ marketId: this.marketId, force: false }) // Market.getMarket();
    } catch (error) {
      console.log(error)
    }
    if (!market) {
      this.enableRDWebService = false
    } else if (market.setting) {
      this.enableRDWebService = this.getMarketEnableRDWebService
    } else {
      this.enableRDWebService = false
    }
    this.initData(this.value)
    this.isFirst = false
  },
  data() {
    return {
      marketId: this.$route.params.marketId,
      isFirst: true,
      isHidden: false,
      numberIsCorrect: false,
      formatIsCorrect: false,
      text: '',
      tooltipText: '',
      isDialog: false,
      isLoading: false,
      dataTIN: null,
      dataVAT: null,
      isShowTINFieldData: false,
      enableRDWebService: true,
      showTINFieldData: [
        "Amphur",
        "BranchName",
        "BranchNumber",
        "BranchTitleName",
        "BuildingName",
        "BusinessFirstDate",
        "FloorNumber",
        "HouseNumber",
        "MooNumber",
        "NID",
        "Name",
        "PostCode",
        "Province",
        "RoomNumber",
        "SoiName",
        "StreetName",
        "Surname",
        "TIN",
        "Thambol",
        "TitleName",
        "VillageName",
        "Yaek",
      ],

      internalSuccessText: '',
      internalWarningText: ''
    };
  },
  methods: {
    ...mapActions({
      checkTaxID: 'customer/checkTaxID',
      getMarket: 'markets/getMarket'
    }),
    initData(citizenId) {
      let { isHidden, numberIsCorrect, formatIsCorrect, text, tooltipText } = this.validateThaiCitizenIDStatus(citizenId, this.isVat, this.enableRDWebService)
      this.isHidden = isHidden
      this.formatIsCorrect = formatIsCorrect
      this.text = text
      this.tooltipText = tooltipText
      this.numberIsCorrect = numberIsCorrect
    },
    checkTaxIDFn() {
      this.$emit("onWriteData", this.dataVAT);
      this.isDialog = false
    }
  },
};
</script>

<style lang="scss" scoped>
.warning-chip {
  display: inline-block;

  .v-icon {
    margin-right: 5px;
  }

  .v-icon.hide-icon {
    margin-right: 0;
  }
}

.warning-div {
  border-width: 0 !important;

  .v-icon {
    margin-right: 5px;
  }

  .v-icon.hide-icon {
    margin-right: 0;
  }
}

.hide-chip {
  display: none;
}


.container-box {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 15px;
}

.header-tax {
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  margin: 15px 0;

  div {
    padding: 5px;
  }
}

.box-id-check {
  // width: calc(50% - 10px);
  flex: 1;
  text-align: center;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 10px;
  padding: 15px;
  min-width: 400px;
  max-width: 500px;

  .status-box {
    width: 100%;

    div {
      margin: 5px;
    }

    .header-status {
      font-size: 18px;
    }

    .v-icon {
      font-size: 55px;
      margin: 10px;
    }

    .text-status {
      font-size: 18px;
      font-weight: 500;
    }
  }

  .company-data-box {
    position: relative;

    // display: flex;
    div {
      width: 100%;
      margin: 5px 0;
      opacity: 1;
      max-height: 600px;
      transition: opacity .8s, max-height .5s;
      overflow: hidden
    }

    .company-name {
      font-size: 17px;
    }

    .hide-data {
      opacity: 0;
      max-height: 0;
      transition: opacity .3s, max-height .5s;
    }
  }
}

.box-error {
  text-align: center;
  font-size: 25px;
  line-height: 35px;
  padding: 40px 0;
  color: var(--v-warning-base);
}

.note {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  text-indent: 20px;
  margin: 0;
  color: gray;

  img.logo {
    width: 200px;
    height: auto;
    margin-left: 15px;
  }
}

.note.right {
  width: 100%;
  text-align: right;
  font-size: 15px;
  font-weight: 500;

  a {
    color: var(--v-info-base);
    text-decoration: underline;
  }
}
</style>
